import numeral from 'numeral';
import { InputAdornment } from '@mui/material';
import { NumericFormat } from 'react-number-format';
import { forwardRef } from 'react';

// ----------------------------------------------------------------------

export function fCurrency(number) {
  return numeral(number).format(Number.isInteger(number) ? '₱ 0,0' : '₱ 0,0.00');
}

export function fPercent(number) {
  return numeral(number / 100).format('0.0%');
}

export function fNumber(number) {
  return numeral(number).format();
}

export function fShortenNumber(number) {
  return numeral(number).format('0.00a').replace('.00', '');
}

export function fData(number) {
  return numeral(number).format('0.0 b');
}

export function fGrade(number) {
  if (Number.isNaN(parseFloat(number))){
    return number
  }
  return parseFloat(number).toFixed(2);
}

// ----------------------------------------------------------------------

const startAdornment = <InputAdornment position="start">₱ </InputAdornment>;

const inputComponent = forwardRef((props, ref) => {
  const { inputRef, onChange, ...other } = props;
  return (
    <NumericFormat
      {...other}
      getInputRef={(inputRef) => {
        ref(inputRef ? inputRef.inputElement : null);
      }}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.floatValue,
          },
        });
      }}
      isAllowed={(values) => {
        const { formattedValue, floatValue } = values;
        return formattedValue === '' || floatValue <= 10000000000000;
      }}
      placeholder="0.00"
      decimalScale={2}
      fixedDecimalScale
      thousandSeparator
      allowNegative={false}
    />
  );
});

export const inputCurrency = {
  startAdornment,
  inputComponent,
};
